import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UniversityPerson } from '../models';

export class UniversityPersonSearchService {
    private readonly apiUrl = 'api/universityperson';

    constructor(
        private readonly httpClient: HttpClient
    ) {
    }

    searchUniversityPersons(value: string): Observable<UniversityPerson[]> {
        return this.httpClient.post<UniversityPerson[]>(`${this.apiUrl}/Search/Active`, { Value: value });
    }
}